import { Col, Row } from 'antd';
import React from 'react'
import { Card } from '../../common/UIComponents';
import { renderModifiedGroup, renderRegularGroup } from '../AllOrgActivities/formHelper';
import { accessorialColumns, groupDifferencesByAction } from '../AllOrgActivities/helper';

export const AllAccessorialsDetails = ({data,objKey,title}) => {

  const renderEntireGroup = (changes, title, type, columns,specTitle) => {
    if (!changes?.length) return null;
    return(
      <div>
      <h4
        className="ant-typography ant-typography-md font-medium mb-3"
        style={{ textAlign: "left", fontSize: "16px" }}
      >
        {title}
      </h4>
      <Card
      style={{
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
      }}
      >
        {renderRegularGroup(changes, title, type, columns,specTitle)}
      </Card>
      </div>
    )
  }

  const renderDetails = () => {
    const incomingData = data?.difference[0]?.[objKey] ?? [];
    const incomingAction = data?.difference[0]?.[objKey]?.[0]?.action;  
    const groupedDifferences = groupDifferencesByAction({ action: incomingAction, difference: incomingData });
    const incomingEntry = incomingData[0]?.new_value ? "New Entry" : "Old Entry";
    const showDataOrNot = 
    (
      !_.isEmpty(incomingData[0]?.old_value) && 
      Object.values(incomingData[0]?.old_value).some(value => value !== null)
    ) || 
    !_.isEmpty(incomingData[0]?.new_value);
      return (
      showDataOrNot && (
      <div className="mt-6">
          <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
              <span style={{ fontSize: '20px', color: '#395484' }}>{title}</span>
              <div className="mt-6">
                  {renderEntireGroup(groupedDifferences.REMOVED, 'Deleted Entry', 'REMOVED', accessorialColumns, title)}
                  {renderEntireGroup(groupedDifferences.ADDED, incomingEntry, 'ADDED', accessorialColumns, title)}
                  {renderModifiedGroup(groupedDifferences.MODIFIED,accessorialColumns, title)}
              </div>
          </h4>
      </div>
      )
    )
  }

  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>{renderDetails()}</Col>
    </Row>
  )
}